export const resolveEventStreamSerdeConfig = input => Object.assign(input, {
  eventStreamMarshaller: input.eventStreamSerdeProvider(input)
});